import { svg } from "lit";
const icon = svg `<path d="M30.777 25.6L34.5769 29.0653V31.3345H25.1347V42.3652L24.0001 43.4998L22.8655 42.3652V31.3345H13.4233V29.0653L17.0002 25.6V9.2692H14.6348V7H33.1424V9.2692H30.777V25.6ZM16.4925 29.0653H31.2847L28.5078 26.4307V9.2692H19.2694V26.4307L16.4925 29.0653Z" fill="currentColor"/>`;
export default icon;
